import './styles.scss';

function MainTitleDescription({ title, description }) {
  return (
    <div className="MainTitleDescription-container">
      <p className="MainTitleDescription-title">{title}</p>
      <p className="MainTitleDescription-description">{description}</p>
    </div>
  );
}

export default MainTitleDescription;
